module.exports = __webpack_public_path__ + "img/wishlist-heart-userprofile.00993565.svg";